module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/7da192543f5921c1d541937198c0afa9.gif";